import "./LogoAnimation.html";
import "./LogoAnimation.scss";

import type { IComponentOptions } from "angular";

export class LogoAnimationComponent implements IComponentOptions {
    public templateUrl: string;

    public bindings = {
        withShadow: "<?",
    };

    constructor() {
        this.templateUrl = "/App/Modules/Gui/Components/LogoAnimation/LogoAnimation.html";
    }
}
